import { styled } from '@mui/material';

export const ParamBoxDiv = styled('div')({
  marginTop: '5px',
  padding: '10px 10px 0px 10px',
  borderRadius: '10px',
  marginBottom: '10px',
});
